module.exports = __webpack_public_path__ + "img/20.ce68ed72.png";